import { TableCell } from '@toggle/design-system';
import { checkCellValueStyle } from '@toggle/helpers/src/utils/table/table';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { TooltipContainer } from '@/components/tooltip-container/TooltipContainer';
import { formatPercentageNumber } from '@/utils/asset/assetUtils';

import * as S from './PastEpisodeCell.styles';

interface EpisodeCellProps {
  value: number;
}

export const PastEpisodeCell = ({ value }: EpisodeCellProps) => {
  const { t } = useTranslation('common');

  return (
    <TableCell numericalValueStyle={checkCellValueStyle(value)} condensed>
      <TooltipContainer label={t('table.median')} inPortal>
        <S.MedianBadgeContainer>
          <S.MedianBadge>M</S.MedianBadge>
          {formatPercentageNumber(value)}
        </S.MedianBadgeContainer>
      </TooltipContainer>
    </TableCell>
  );
};
